<template>
  <div class="main">
    <Header
      :show="true"
      title="车辆道闸"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        wrapable
        :scrollable="false"
        text="请先观察现场情况，在确保安全的情况下放行。"
      />
      <van-form>
        <van-cell
          :value="listQuery.area.name"
          is-link
          required
          @click="listQuery.area.show = true"
        >
          <template #title>
            <span style="font-size: 2vh;">访问区域</span>
          </template>
        </van-cell>
        <van-action-sheet
          v-model="listQuery.area.show"
          :actions="listQuery.area.actions"
          cancel-text="取消"
          description="请选择访问区域"
          @select="onSelectAreaChoose"
        />
        <van-field
          name="checkboxGroup"
          label="操作方向"
          required
          input-align="right"
          :rules="[{ required: true }]"
        >
          <template #input>
            <van-radio-group v-model="listQuery.switch" direction="horizontal">
              <van-radio :name="1">开闸</van-radio>
              <van-radio :name="2">关闸</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-cell
          :value="listQuery.reason.name"
          is-link
          required
          @click="listQuery.reason.show = true"
        >
          <template #title>
            <span style="font-size: 2vh;">放行理由</span>
          </template>
        </van-cell>
        <van-action-sheet
          v-model="listQuery.reason.show"
          :actions="listQuery.reason.actions"
          cancel-text="取消"
          description="请选择放行理由"
          @select="onSelectReasonChoose"
        />
        <div style="margin: 16px;" v-if="checkPermission([312])">
          <van-button round block type="info" @click="handleOperateConfirmDialog">
            确定
          </van-button>
        </div>
      </van-form>

      <van-dialog
        v-model="dialogVisibleOperate"
        title="确认放行？"
        show-cancel-button
        :before-close="handleBeforeCloseDialog"
      >
        <div style="display: flex; justify-content: center; align-items: center; font-size: 2vh; margin: 20px 0;">
          放行区域：{{ listQuery.area.name }}
        </div>
      </van-dialog>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import { mapGetters } from "vuex"
  import { Dialog } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { updateOfficeGateOne, updateMaterialGateOne } from '@/api/car.js'

  export default {
    name: "ServiceControlCar",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        loading: false,
        dialogVisibleOperate: false,
        listQuery: {
          area: {
            show: false,
            actions: [
              { name: '办公区', subname: '' },
              { name: '原料区' }
            ],
            name: '原料区'
          },
          switch: 0,
          reason: {
            show: false,
            actions: [
              { name: '临时放行', subname: '' },
              { name: '系统故障' },
              { name: '其他' }
            ],
            name: ''
          }
        }
      }
    },
    computed: {

    },
    watch: {

    },
    beforeCreate() {

    },
    created() {

    },
    beforeMount() {

    },
    mounted() {

    },
    beforeUpdate() {

    },
    updated() {

    },
    beforeDestroy() {

    },
    destroyed() {

    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        console.log('control-left')
      },
      onSelectAreaChoose(item) {
        this.listQuery.area.show = false
        this.listQuery.area.name = item.name
      },
      onSelectReasonChoose(item) {
        this.listQuery.reason.show = false
        this.listQuery.reason.name = item.name
      },
      handleOperateConfirmDialog() {
        if ((this.listQuery.switch === 0)) {
          showPhoneAlarm(true, 'toast', null, 2000, 500, null, '请选择操作方向：开闸或关闸')
        } else if ((this.listQuery.reason.name === '')) {
          showPhoneAlarm(true, 'toast', null, 2000, 500, null, '请选择放行事由')
        } else {
          this.dialogVisibleOperate = true
        }
      },
      handleBeforeCloseDialog(action, done) {
        if (action === 'confirm') {
          const data = {
            value: this.listQuery.switch,
            reason: this.listQuery.reason.name
          }
          if (this.listQuery.area.name === '办公区') {
            updateOfficeGateOne(data).then(response => {
              const { data } = response
              if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '办公区道闸放行', data.message)) {
                done(true)
              }
            }).catch(function(error) {
              this.loading = false
            })
          } else {
            updateMaterialGateOne(data).then(response => {
              const { data } = response
              if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '原料区道闸放行', data.message)) {
                done(true)
              }
            }).catch(function(error) {
              this.loading = false
            })
          }
        } else {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, null, '取消放行')
          done(true)
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  // 系统样式修改

  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F7F8FA;
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
</style>
